//import Swiper from 'swiper'
import Swiper, { Navigation, Pagination } from 'swiper';


class MySwiper3 {
	constructor() {
		this._init()
	}
	_init() {
        
        this.el = document.querySelector('[home-prod-swiper]')

		if(!this.el) {
			return
		}

		Swiper.use([Navigation]);
		
		var swiper = new Swiper('.home-highlight-prod__swiper-container', {
			slidesPerView: 1.5,
			spaceBetween: 15,
			direction: 'horizontal',

			breakpoints: {
				// when window width is <= 1024px
				1024: {
					slidesPerView: 3,
					spaceBetween: 60,
				}
			},
			navigation: {
				nextEl: ".swiper-button-next.home-highlight-prod__btn_next",
				prevEl: ".swiper-button-prev.home-highlight-prod__btn_prev"
			}
        });
	}
}
export default MySwiper3